import { Controller } from "stimulus"

import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["content", "frame"]

  initialize() {
    this.page = 1;
  }

  next_page() {
    this.page++;
    const url = window.location.pathname + "?usage_page=" + this.page

    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (data) => {
        this.contentTarget.insertAdjacentHTML('beforeend', data.entries);
        this.frameTarget.style.maxHeight = this.frameTarget.scrollHeight + "px";
      }
    })
  }

}